import { $build, Strophe } from "strophe.js";

// http://xmpp.org/extensions/xep-0059.html

Strophe.addNamespace('RSM', 'http://jabber.org/protocol/rsm');

type RSMOptions = {
    max?: number

    first?: number
    last?: number

    after?: `${number}`
    before?: `${number}`

    index?: number
    count?: number
} | { xml: Element }

export class RSM {
    private attribs = ['max', 'first', 'last', 'after', 'before', 'index', 'count'] as const;
    private index: number;
    private last: `${number}`;
    private first: `${number}`;

    constructor(options: RSMOptions) {
        if ('xml' in options && typeof options.xml !== 'undefined') {
            this.fromXMLElement(options.xml);
        } else {
            for (let ii = 0; ii < this.attribs.length; ii++) {
                const attrib = this.attribs[ii];
                this[attrib] = options[attrib];
            }
        }
    }

    toXML() {
        let xml = $build('set', {xmlns: Strophe.NS.RSM});
        for (const attrib of this.attribs) {
            if (typeof this[attrib] !== 'undefined') {
                xml = xml.c(attrib).t(this[attrib].toString()).up();
            }
        }
        return xml.tree();
    }

    next(max: number) {
        const newSet = new RSM({max: max, after: this.last});
        return newSet;
    }

    previous(max: number) {
        const newSet = new RSM({max: max, before: this.first});
        return newSet;
    }

    fromXMLElement(xmlElement: Element) {
        for (let ii = 0; ii < this.attribs.length; ii++) {
            const attrib = this.attribs[ii];
            const elem = xmlElement.getElementsByTagName(attrib)[0];
            if (typeof elem !== 'undefined' && elem !== null) {
                this[attrib] = Strophe.getText(elem);
                if (attrib === 'first') {
                    this.index = parseInt(elem.getAttribute('index'), 10);
                }
            }
        }
    }
}
